// api.js
// All API calls live here. When your backend is ready,
// set REACT_APP_API_URL in your Netlify environment variables
// and all calls will automatically use the real data.

const API_URL = process.env.REACT_APP_API_URL || null;

// ─── MOCK DATA ────────────────────────────────────────────────────────────
// Used when REACT_APP_API_URL is not set (local dev / demo mode)

const MOCK_LEADS = [
  {
    id: "1", score: 92, tier: "hot", status: "new",
    company: {
      name: "Midwest Health System", domain: "midwesthealthsystem.org",
      industry: "healthcare", employee_count: 420,
      location: "Chicago, IL", revenue_estimate: "$50M-$100M",
      contacts: [
        { name: "Sarah Chen", title: "Chief Digital Officer", email: "s.chen@midwesthealthsystem.org" },
        { name: "Marcus Webb", title: "VP of Marketing", email: "m.webb@midwesthealthsystem.org" }
      ]
    },
    signals: [
      { type: "legacy_cms", weight: 25, raw_weight: 25, detail: "Drupal 7 detected across primary and subdomain sites", days_ago: 3, source_type: "wappalyzer", source_label: "Wappalyzer scan", source_url: "https://www.wappalyzer.com", source_detail: "Drupal 7.98 detected on midwesthealthsystem.org and 4 subdomain sites via HTTP headers and page source analysis." },
      { type: "leadership_change", weight: 25, raw_weight: 25, detail: "New Chief Digital Officer appointed", days_ago: 8, source_type: "news", source_label: "Modern Healthcare", source_url: "https://www.modernhealthcare.com", source_detail: "Midwest Health System Names Sarah Chen as First Chief Digital Officer. Hire announced from Mayo Clinic Digital." },
      { type: "compliance_pressure", weight: 22, raw_weight: 22, detail: "ADA website accessibility lawsuit filed", days_ago: 12, source_type: "news", source_label: "Court Listener", source_url: "https://www.courtlistener.com", source_detail: "Class action accessibility suit filed in Northern District of Illinois citing WCAG 2.1 AA non-compliance across patient portal and main site." },
      { type: "poor_performance", weight: 15, raw_weight: 15, detail: "PageSpeed 28/100, Core Web Vitals failing", days_ago: 3, source_type: "pagespeed", source_label: "Google PageSpeed API", source_url: "https://pagespeed.web.dev", source_detail: "Mobile: 28/100. LCP 8.4s, CLS 0.42, FID 380ms. Desktop: 41/100. All three Core Web Vitals failing." }
    ],
    combos: [
      { bonus: 15, description: "New leader + legacy CMS = high replacement likelihood" },
      { bonus: 15, description: "Compliance deadline + legacy CMS = forced migration" }
    ],
    firm: [
      { value: 10, detail: "High-fit vertical: healthcare" },
      { value: 10, detail: "420 employees - ideal size" },
      { value: 5, detail: "Contacts available" }
    ]
  },
  {
    id: "2", score: 78, tier: "hot", status: "new",
    company: {
      name: "Brightfield University", domain: "brightfield.edu",
      industry: "higher_education", employee_count: 1800,
      location: "Columbus, OH", revenue_estimate: "$200M+",
      contacts: [{ name: "Dr. Patricia Moore", title: "Chief Information Officer", email: "p.moore@brightfield.edu" }]
    },
    signals: [
      { type: "legacy_cms", weight: 25, raw_weight: 25, detail: "Drupal 7 across 14 department sites", days_ago: 5, source_type: "wappalyzer", source_label: "Wappalyzer scan", source_url: "https://www.wappalyzer.com", source_detail: "Drupal 7.98 detected on brightfield.edu and 13 subdomain sites including law.brightfield.edu, med.brightfield.edu, and engineering.brightfield.edu." },
      { type: "funding_event", weight: 18, raw_weight: 18, detail: "Endowment reaches $2.1B milestone", days_ago: 14, source_type: "news", source_label: "Columbus Dispatch", source_url: "https://www.dispatch.com", source_detail: "Brightfield University Endowment Crosses $2 Billion Mark. University president quoted: This positions us to invest in our digital infrastructure." },
      { type: "job_posting", weight: 22, raw_weight: 25, detail: "Drupal architect + web platform manager posted", days_ago: 7, source_type: "job", source_label: "Adzuna job posting", source_url: "https://www.adzuna.com", source_detail: "Two simultaneous postings: Senior Drupal Architect ($110k-$130k) and Web Platform Manager ($95k-$115k). Both mention platform modernization and migration from Drupal 7." }
    ],
    combos: [
      { bonus: 12, description: "Legacy CMS + hiring = active platform evaluation" },
      { bonus: 10, description: "New money + legacy platform = budget exists" }
    ],
    firm: [
      { value: 10, detail: "High-fit: higher_education" },
      { value: 5, detail: "1800 employees" },
      { value: 5, detail: "Contacts available" }
    ]
  },
  {
    id: "3", score: 64, tier: "hot", status: "reviewed",
    company: {
      name: "Stackform", domain: "stackform.io",
      industry: "b2b_saas", employee_count: 180,
      location: "Austin, TX", revenue_estimate: "$15M-$30M",
      contacts: [
        { name: "Tomas Rivera", title: "VP of Marketing", email: "t.rivera@stackform.io" },
        { name: "Jess Kim", title: "Head of Content", email: "j.kim@stackform.io" }
      ]
    },
    signals: [
      { type: "funding_event", weight: 18, raw_weight: 18, detail: "Raises $22M Series B", days_ago: 18, source_type: "news", source_label: "TechCrunch", source_url: "https://techcrunch.com", source_detail: "Stackform Raises $22M Series B to Expand Enterprise Go-to-Market. CEO quoted: We are doubling our marketing investment and completely rethinking our web presence." },
      { type: "b2b_rebrand", weight: 22, raw_weight: 22, detail: "New brand identity unveiled", days_ago: 10, source_type: "news", source_label: "Business Wire", source_url: "https://www.businesswire.com", source_detail: "Stackform Unveils New Brand Identity Ahead of Enterprise Push. New logo and positioning announced. Website listed as coming soon." },
      { type: "leadership_change", weight: 20, raw_weight: 25, detail: "New VP of Marketing joins from HubSpot", days_ago: 22, source_type: "news", source_label: "LinkedIn", source_url: "https://www.linkedin.com", source_detail: "Tomas Rivera posted: Excited to join Stackform as VP of Marketing. First priority: rebuilding our digital presence from the ground up." }
    ],
    combos: [
      { bonus: 18, description: "B2B rebrand + new leader = new site near certain" },
      { bonus: 15, description: "B2B rebrand + funding = budget aligned" }
    ],
    firm: [
      { value: 10, detail: "High-fit: b2b_saas" },
      { value: 10, detail: "180 employees - ideal size" },
      { value: 8, detail: "Series B sweet spot" }
    ]
  },
  {
    id: "4", score: 52, tier: "warm", status: "new",
    company: {
      name: "Natl. Assoc. of Community Lenders", domain: "nacl.org",
      industry: "nonprofit", employee_count: 65,
      location: "Washington, DC", revenue_estimate: "$5M-$15M",
      contacts: [{ name: "Diana Osei", title: "Executive Director", email: "d.osei@nacl.org" }]
    },
    signals: [
      { type: "leadership_change", weight: 25, raw_weight: 25, detail: "New Executive Director appointed", days_ago: 30, source_type: "news", source_label: "Nonprofit Times", source_url: "https://www.thenonprofittimes.com", source_detail: "NACL Names Diana Osei as Executive Director. Board chair quoted: Diana will modernize how we communicate our mission digitally." },
      { type: "legacy_cms", weight: 12, raw_weight: 25, detail: "WordPress 4.8 detected - heavily outdated", days_ago: 45, source_type: "wappalyzer", source_label: "Wappalyzer scan", source_url: "https://www.wappalyzer.com", source_detail: "WordPress 4.8.23 detected on nacl.org. Latest version is 6.5. Multiple outdated plugins detected including a 2019 events calendar." },
      { type: "poor_performance", weight: 8, raw_weight: 15, detail: "PageSpeed 41/100", days_ago: 28, source_type: "pagespeed", source_label: "Google PageSpeed API", source_url: "https://pagespeed.web.dev", source_detail: "Mobile: 41/100. LCP 6.1s, CLS 0.18. Site served from shared hosting with no CDN. Images unoptimized averaging 480kb per image." }
    ],
    combos: [{ bonus: 15, description: "New leader + legacy CMS = high replacement likelihood" }],
    firm: [
      { value: 10, detail: "High-fit: nonprofit" },
      { value: 10, detail: "65 employees" },
      { value: 5, detail: "Contacts available" }
    ]
  },
  {
    id: "5", score: 44, tier: "warm", status: "new",
    company: {
      name: "Cascade Media Group", domain: "cascademedia.com",
      industry: "media_publishing", employee_count: 290,
      location: "Seattle, WA", revenue_estimate: "$25M-$50M",
      contacts: []
    },
    signals: [
      { type: "org_change", weight: 20, raw_weight: 20, detail: "Acquires Pacific Northwest Tribune", days_ago: 20, source_type: "news", source_label: "Seattle Times", source_url: "https://www.seattletimes.com", source_detail: "Cascade Media Group Acquires Pacific Northwest Tribune in $14M Deal. Two separate CMS platforms will need consolidation." },
      { type: "strategy_announced", weight: 15, raw_weight: 15, detail: "Digital-first editorial strategy announced", days_ago: 16, source_type: "news", source_label: "Poynter", source_url: "https://www.poynter.org", source_detail: "Cascade Media Group CEO: Our current CMS is a patchwork that cannot support where journalism is going. We need a unified platform." },
      { type: "job_posting", weight: 15, raw_weight: 15, detail: "Editorial platform engineer posted", days_ago: 9, source_type: "job", source_label: "Adzuna", source_url: "https://www.adzuna.com", source_detail: "Senior Editorial Platform Engineer. Requirements include experience with headless CMS architecture and migrating from legacy publishing platforms." }
    ],
    combos: [{ bonus: 8, description: "Strategy + hiring = execution approaching" }],
    firm: [
      { value: 10, detail: "High-fit: media_publishing" },
      { value: 10, detail: "290 employees" },
      { value: -5, detail: "No contacts found" }
    ]
  },
  {
    id: "6", score: 38, tier: "warm", status: "contacted",
    company: {
      name: "Riverstone Credit Union", domain: "riverstoneccu.com",
      industry: "financial_services", employee_count: 140,
      location: "Denver, CO", revenue_estimate: "$10M-$25M",
      contacts: [{ name: "Brad Nilsson", title: "VP Digital Banking", email: "b.nilsson@riverstoneccu.com" }]
    },
    signals: [
      { type: "pain_signal", weight: 12, raw_weight: 12, detail: "CEO publicly expressed frustration with current site", days_ago: 35, source_type: "news", source_label: "CU Today", source_url: "https://www.cutoday.info", source_detail: "CEO Mark Hendricks: Honestly, our website is embarrassing. It does not reflect who we are. We are actively looking at what it would take to rebuild it properly." },
      { type: "job_posting", weight: 13, raw_weight: 15, detail: "Digital experience manager posted", days_ago: 28, source_type: "job", source_label: "Adzuna", source_url: "https://www.adzuna.com", source_detail: "Digital Experience Manager. Description includes lead website redesign initiative and evaluate and select new CMS platform. $75k-$90k." },
      { type: "legacy_cms", weight: 10, raw_weight: 25, detail: "WordPress 4.2 detected", days_ago: 60, source_type: "wappalyzer", source_label: "Wappalyzer scan", source_url: "https://www.wappalyzer.com", source_detail: "WordPress 4.2.29 detected on riverstoneccu.com. WP 4.2 reached end of life in 2017. jQuery 1.11.3 also detected." }
    ],
    combos: [{ bonus: 8, description: "Expressed pain + hiring = evaluating solutions" }],
    firm: [
      { value: 10, detail: "High-fit: financial_services" },
      { value: 10, detail: "140 employees" },
      { value: 5, detail: "Contacts available" }
    ]
  },
  {
    id: "7", score: 22, tier: "cold", status: "new",
    company: {
      name: "Apex Fabrication Solutions", domain: "apexfab.com",
      industry: "b2b_manufacturing", employee_count: 310,
      location: "Cincinnati, OH", revenue_estimate: "$40M-$80M",
      contacts: []
    },
    signals: [
      { type: "b2b_expansion", weight: 15, raw_weight: 15, detail: "Expanding into European markets", days_ago: 25, source_type: "news", source_label: "PR Newswire", source_url: "https://www.prnewswire.com", source_detail: "Apex Fabrication Solutions Opens Frankfurt Office. Press release mentions need for multilingual web presence to support new EU customers." },
      { type: "legacy_cms", weight: 10, raw_weight: 25, detail: "No detectable CMS - likely bespoke PHP", days_ago: 55, source_type: "wappalyzer", source_label: "Wappalyzer scan", source_url: "https://www.wappalyzer.com", source_detail: "No CMS framework detected. PHP 7.2 server headers. Likely hand-coded or legacy custom CMS from early 2010s." }
    ],
    combos: [],
    firm: [
      { value: 5, detail: "Medium-fit: manufacturing" },
      { value: 10, detail: "310 employees" },
      { value: -5, detail: "No contacts" }
    ]
  }
];

const MOCK_TARGETS = [
  { id: "t1", domain: "midwesthealthsystem.org", name: "Midwest Health System", industry: "healthcare", priority: "high", status: "active", source: "csv", scanned: 3 },
  { id: "t2", domain: "brightfield.edu", name: "Brightfield University", industry: "higher_education", priority: "high", status: "active", source: "csv", scanned: 5 },
  { id: "t3", domain: "stackform.io", name: "Stackform", industry: "b2b_saas", priority: "normal", status: "active", source: "auto_job", scanned: 2 },
  { id: "t4", domain: "nacl.org", name: "Natl. Assoc. of Community Lenders", industry: "nonprofit", priority: "normal", status: "active", source: "csv", scanned: 7 },
  { id: "t5", domain: "riverstoneccu.com", name: "Riverstone Credit Union", industry: "financial_services", priority: "normal", status: "contacted", source: "manual", scanned: 4 },
  { id: "t6", domain: "legacy-competitor.com", name: "Legacy Competitor Inc", industry: null, priority: "low", status: "excluded", source: "csv", scanned: null },
  { id: "t7", domain: "apexfab.com", name: "Apex Fabrication Solutions", industry: "b2b_manufacturing", priority: "low", status: "pending_review", source: "auto_news", scanned: null }
];

const MOCK_STATS = {
  leads: { hot: 3, warm: 3, cold: 1, contacted: 1, new_this_week: 4 },
  targets: { total: 7, active: 4, pending: 1, excluded: 1 },
  signal_breakdown: [
    { signal_type: "legacy_cms", count: 7 },
    { signal_type: "job_posting", count: 5 },
    { signal_type: "leadership_change", count: 4 },
    { signal_type: "funding_event", count: 3 },
    { signal_type: "poor_performance", count: 3 }
  ]
};

const MOCK_SETTINGS = {
  verticals: ["b2b_saas", "higher_education", "healthcare", "nonprofit", "media_publishing", "financial_services"],
  thresholds: { hot: 60, warm: 35, cold: 15 },
  signal_weights: { legacy_cms: 25, leadership_change: 25, compliance_pressure: 22, b2b_rebrand: 22, org_change: 20, funding_event: 18, b2b_growth_signal: 16, strategy_announced: 15, b2b_expansion: 15, job_posting: 15, poor_performance: 15, pain_signal: 12, analyst_recognition: 12 },
  firmographic_filters: { employee_min: 50, employee_max: 500 },
  geographic_focus: ["United States"],
  custom_keywords: ["credit union CMS", "law firm web platform"],
  competitor_exclusions: ["Acquia", "WP Engine"],
  excluded_domains: ["legacy-competitor.com"]
};

const MOCK_PIPELINE_STATUS = {
  news_monitor: { status: "completed", last_run: "6h ago", has_error: false },
  job_monitor: { status: "completed", last_run: "6h ago", has_error: false },
  wappalyzer_scan: { status: "completed", last_run: "2d ago", has_error: false },
  pagespeed_scan: { status: "completed", last_run: "2d ago", has_error: false },
  scoring: { status: "completed", last_run: "1h ago", has_error: false },
  full_pipeline: { status: "idle", last_run: "2d ago", has_error: false }
};

const MOCK_RUNS = [
  { id: "r1", job_name: "full_pipeline", status: "completed", triggered_by: "scheduler", started_at: new Date(Date.now() - 6 * 3600000).toISOString(), duration_seconds: 2280, stats: { news_stored: 14, jobs_stored: 28, new_leads: 6, tier_changes: 3 } },
  { id: "r2", job_name: "scoring", status: "completed", triggered_by: "dashboard", started_at: new Date(Date.now() - 3600000).toISOString(), duration_seconds: 95, stats: { hot: 12, warm: 28, cold: 19, new_leads: 0 } },
  { id: "r3", job_name: "news_monitor", status: "failed", triggered_by: "dashboard", started_at: new Date(Date.now() - 1800000).toISOString(), duration_seconds: 45, stats: {} }
];

// ─── API HELPERS ──────────────────────────────────────────────────────────

async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options
  });
  if (!res.ok) throw new Error(`API error ${res.status}: ${path}`);
  return res.json();
}

// ─── PUBLIC API ───────────────────────────────────────────────────────────
// Each function returns real data if API_URL is set, mock data otherwise.
// Your developer only needs to match these response shapes in the backend.

export async function getLeads(params = {}) {
  if (!API_URL) {
    const { tier, vertical, search } = params;
    let leads = [...MOCK_LEADS];
    if (tier) leads = leads.filter(l => l.tier === tier);
    if (vertical) leads = leads.filter(l => l.company.industry === vertical);
    if (search) {
      const q = search.toLowerCase();
      leads = leads.filter(l => l.company.name.toLowerCase().includes(q) || l.company.domain.includes(q));
    }
    return { leads, total: leads.length, page: 1, total_pages: 1 };
  }
  const query = new URLSearchParams(params).toString();
  return apiFetch(`/api/leads?${query}`);
}

export async function updateLead(id, body) {
  if (!API_URL) return { status: "updated" };
  return apiFetch(`/api/leads/${id}`, { method: "PATCH", body: JSON.stringify(body) });
}

export async function getLeadNotes(id) {
  if (!API_URL) return [];
  return apiFetch(`/api/leads/${id}/notes`);
}

export async function getLeadCounts() {
  if (!API_URL) return { hot: 3, warm: 3, cold: 1, total: 7 };
  return apiFetch("/api/leads/counts");
}

export async function getTargets(params = {}) {
  if (!API_URL) {
    const { status, search } = params;
    let targets = [...MOCK_TARGETS];
    if (status) targets = targets.filter(t => t.status === status);
    if (search) {
      const q = search.toLowerCase();
      targets = targets.filter(t => t.domain.includes(q) || (t.name || "").toLowerCase().includes(q));
    }
    return { targets, total: targets.length };
  }
  const query = new URLSearchParams(params).toString();
  return apiFetch(`/api/targets?${query}`);
}

export async function updateTarget(id, body) {
  if (!API_URL) return { status: "updated" };
  return apiFetch(`/api/targets/${id}`, { method: "PATCH", body: JSON.stringify(body) });
}

export async function addManualTarget(body) {
  if (!API_URL) return { id: `t${Date.now()}`, ...body, status: "active" };
  return apiFetch("/api/targets/manual", { method: "POST", body: JSON.stringify(body) });
}

export async function previewCsvUpload(file) {
  if (!API_URL) {
    return {
      summary: { will_add: 12, duplicates: 3, will_exclude: 1, errors: 1 },
      valid_rows: [],
      duplicate_domains: [],
      exclude_domains: [],
      errors: [{ row: 7, domain: "notadomain", error: "Invalid domain format" }]
    };
  }
  const form = new FormData();
  form.append("file", file);
  const res = await fetch(`${API_URL}/api/targets/upload/preview`, { method: "POST", body: form });
  return res.json();
}

export async function confirmCsvUpload(validRows, excludeDomains) {
  if (!API_URL) return { status: "imported", added: validRows.length };
  return apiFetch("/api/targets/upload/confirm", {
    method: "POST",
    body: JSON.stringify({ valid_rows: validRows, exclude_domains: excludeDomains })
  });
}

export async function downloadCsvTemplate() {
  if (!API_URL) return;
  window.open(`${API_URL}/api/targets/template`, "_blank");
}

export async function getStats() {
  if (!API_URL) return MOCK_STATS;
  return apiFetch("/api/stats");
}

export async function getSettings() {
  if (!API_URL) return MOCK_SETTINGS;
  return apiFetch("/api/settings");
}

export async function updateSettings(body) {
  if (!API_URL) return { status: "saved" };
  return apiFetch("/api/settings", { method: "PATCH", body: JSON.stringify(body) });
}

export async function getPipelineJobs() {
  if (!API_URL) {
    return {
      news_monitor: { label: "News Monitor", icon: "📰", estimated_minutes: 5, description: "Scans Google News RSS for leadership changes, funding events, rebrands, and strategy announcements" },
      job_monitor: { label: "Job Monitor", icon: "💼", estimated_minutes: 8, description: "Scans Adzuna for CMS, platform, and B2B marketing job postings" },
      wappalyzer_scan: { label: "Tech Scan", icon: "🔍", estimated_minutes: 15, description: "Scans active target domains for CMS and technology stack detection" },
      pagespeed_scan: { label: "Perf Scan", icon: "⚡", estimated_minutes: 10, description: "Runs Google PageSpeed audits on domains with existing signals" },
      scoring: { label: "Scoring", icon: "🎯", estimated_minutes: 2, description: "Re-scores all companies with active signals and updates tier classifications" },
      full_pipeline: { label: "Full Pipeline", icon: "🚀", estimated_minutes: 40, description: "Runs all jobs in sequence: news, jobs, tech scan, performance, scoring" }
    };
  }
  return apiFetch("/api/pipeline/jobs");
}

export async function triggerJob(jobName) {
  if (!API_URL) return { run_id: `r${Date.now()}`, job_name: jobName, status: "started" };
  return apiFetch(`/api/pipeline/run/${jobName}`, { method: "POST" });
}

export async function getPipelineRuns(params = {}) {
  if (!API_URL) return MOCK_RUNS;
  const query = new URLSearchParams(params).toString();
  return apiFetch(`/api/pipeline/runs?${query}`);
}

export async function getPipelineRun(runId) {
  if (!API_URL) return MOCK_RUNS.find(r => r.id === runId) || MOCK_RUNS[0];
  return apiFetch(`/api/pipeline/runs/${runId}`);
}

export async function getPipelineStatus() {
  if (!API_URL) return MOCK_PIPELINE_STATUS;
  return apiFetch("/api/pipeline/status");
}

export async function getSchedules() {
  if (!API_URL) {
    return {
      news_monitor: { enabled: true, frequency: "daily", time: "02:00", days: ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"], description: "Daily at 2:00 AM" },
      job_monitor: { enabled: true, frequency: "daily", time: "03:00", days: ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"], description: "Daily at 3:00 AM" },
      wappalyzer_scan: { enabled: true, frequency: "weekly", time: "04:00", days: ["sunday"], description: "Weekly on Sunday at 4:00 AM" },
      pagespeed_scan: { enabled: true, frequency: "weekly", time: "05:00", days: ["sunday"], description: "Weekly on Sunday at 5:00 AM" },
      scoring: { enabled: true, frequency: "daily", time: "06:00", days: ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"], description: "Daily at 6:00 AM" },
      full_pipeline: { enabled: false, frequency: "weekly", time: "01:00", days: ["sunday"], description: "Disabled" }
    };
  }
  return apiFetch("/api/schedules");
}

export async function updateSchedule(jobName, body) {
  if (!API_URL) return { status: "saved" };
  return apiFetch(`/api/schedules/${jobName}`, { method: "PATCH", body: JSON.stringify(body) });
}
